import React from 'react';
import { ImageIcon, SkeletonLoading } from '@saleshandy/design-system';
import { Images } from '../../../../../../../shared/app-constants';
import { FieldContentTabs } from '../types';
import TruncatedTextWithTooltip from '../../../../../../../shared/components/truncated-text-with-tooltip';
import hasPermission from '../../../../../../../shared/utils/access-control/has-permission';
import { Permissions } from '../../../../../../../shared/utils/access-control/enums/permissions';

export const getCustomFieldColumns = (onCopyClickHandler, onKeyHandler) => [
  {
    dataField: 'label',
    text: 'Field Name',
    component: (cell, row) => (
      <div className="custom-field-cell-with-ai">
        <TruncatedTextWithTooltip string={cell} length={40} />
        {row?.isAiGenerated && (
          <ImageIcon
            src={Images.NoResultGradient}
            alt="ai-icon"
            className="custom-field-ai-icon"
            width={16}
            height={16}
          />
        )}
      </div>
    ),
    headerLoadingSkeleton: <SkeletonLoading width={54} height={14} />,
    cellLoadingSkeleton: <SkeletonLoading width={72} height={14} />,
  },
  {
    dataField: 'fieldHashedId',
    text: 'Field Id',
    component: (cell) => (
      <div className="field-hashed-id-container">
        <div className="field-hashed-id-content">{cell}</div>
        <span
          tabIndex={0}
          onKeyPress={onKeyHandler}
          role="button"
          onClick={() => {
            onCopyClickHandler(cell);
          }}
          className="field-hashed-id-icon"
        >
          <ImageIcon src={Images.Copy} alt="copy" />
        </span>
      </div>
    ),
    headerLoadingSkeleton: <SkeletonLoading width={54} height={14} />,
    cellLoadingSkeleton: <SkeletonLoading width={72} height={14} />,
  },
  {
    dataField: 'type',
    text: 'Field Type',
    headerLoadingSkeleton: <SkeletonLoading width={54} height={14} />,
    cellLoadingSkeleton: <SkeletonLoading width={72} height={14} />,
  },
];

export const generateActionsColumn = (tab: FieldContentTabs) => {
  let actions = null;

  if (hasPermission(Permissions.FIELD_UPDATE)) {
    actions = [
      {
        displayName: 'Edit',
        icon: 'pencil',
        key: 'edit',
        position: 'out',
      },
    ];
  }

  if (
    hasPermission(Permissions.FIELD_DELETE) &&
    tab === FieldContentTabs.CustomFields
  ) {
    actions = [
      ...actions,
      {
        displayName: 'Delete',
        icon: 'trash',
        key: 'delete',
        position: 'out',
      },
    ];
  }

  return actions;
};

export const getDefaultTableWrapper = (
  t: FieldContentTabs,
  customFieldPaginationCount: number,
  defaultFieldPaginationCount: number,
) => {
  switch (t) {
    case FieldContentTabs.CustomFields:
      return customFieldPaginationCount > 25 ? 'paginated-table' : '';
    case FieldContentTabs.SystemFields:
      return defaultFieldPaginationCount > 25 ? 'paginated-table' : '';
    default:
      return '';
  }
};
